import styled from '@emotion/styled';
import { icons } from '@assets/icons';

export const StyledSelectBox = styled.div`
  position: relative;
  width: 100%;
  min-width: 236px;
  & div {
    border-radius: 4px;
  }
  & ol {
    & li {
      padding: 0 16px;
      justify-content: left;
    }
  }
`;

export const StyledSelectButton = styled.button`
  @keyframes rotateArrow {
    0% {
      transform: rotate(135deg);
    }
    100% {
      transform: rotate(-45deg);
    }
  }
  position: relative;
  width: 100%;
  height: 40px;
  padding: 10px 32px 10px 16px;
  text-align: left;
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  font-size: 14px;
  color: #ccc;

  &.has-value {
    color: #555;
  }
  &:after {
    content: '';
    display: block;
    position: absolute;
    top: 14px;
    right: 16px;
    width: 6px;
    height: 6px;
    border-top: 2px solid #555;
    border-right: 2px solid #555;
    transform: rotate(135deg);
  }
  &:hover {
    border-color: #777;
    &.open {
      border: 1px solid #00bf00;
    }
  }
  &.open {
    border: 1px solid #00bf00;
    &:after {
      top: 16px;
      animation: rotateArrow 0.1s normal forwards linear;
      animation-iteration-count: 1;
    }
  }
`;

export const StyledSelectContents = styled.div`
  z-index: 2;
  position: absolute;
  top: 100%;
  left: 0;
  width: 100%;
  margin: 5px 0;
  padding: 5px;
  border: 1px solid #00bf00;
  background-color: #fff;
  box-sizing: border-box;
  &.list-up {
    top: auto;
    bottom: 100%;
  }
`;

export const StyledSearchInput = styled.div`
  position: relative;
  width: 100%;
  margin: 0 auto;

  & input {
    width: 100%;
    height: 40px;
    border: 1px solid #00bf00;
    box-sizing: border-box;
    border-radius: 4px;
    outline: none;
  }
  & .btn-search {
    position: absolute;
    top: 10px;
    right: 12px;
    width: 20px;
    height: 20px;
    background: url(${icons.search}) no-repeat center center;
    background-size: 16px 16px;
  }
`;

export const StyledSearchList = styled.ul`
  overflow-y: auto;
  position: relative;
  max-height: 129px;
  margin-top: 3px;
  & li {
    margin-right: 4px;
    padding: 5px 14px;
    border-radius: 4px;
    font-size: 14px;
    cursor: pointer;
    & .keyword {
      font-style: normal;
      background-color: #fff89a;
    }
  }
`;

export const StyledResetBtn = styled.button`
  position: absolute;
  top: 12px;
  right: -24px;
  width: 16px;
  height: 16px;
  margin-left: 4px;
  background: url(${icons.iconReset}) no-repeat center center;
  background-size: 16px 16px;
`;
